import {action, makeObservable, observable, reaction} from "mobx";
import {updateBalanceInfoText, updateBetAmountInfoText} from "../controlPanel";
import {setAutoSpinBtnCountdownNumber} from "../controlPanel/autoSpin";
import {getUserBalance} from "../api";
import {store} from "./store";
import {setBuyFreeBetBoardClickable, updateFreeBetBoard} from "../freeSpin";
import {pixiComponents} from "../index";
import {updatePlusMinusButtonsOpacity} from "../controlPanel/betSettingsSection";
import {getStores} from "../slotBoard/spin";

export const boardMatrixExample = [
    [4, 4, 2, 8, 1],
    [2, 2, 4, 7, 7],
    [4, 1, 3, 8, 1],
    [3, 5, 6, 8, 7],
    [5, 3, 3, 3, 3],
    [1, 2, 2, 1, 3]
];

class SpinStore {
    userBalance = 0;
    spinAmount = 500;
    boardMatrix = boardMatrixExample;
    wins = [];
    isWonFreeSpin = false;
    isTurboMode = false;
    isQuickFall = true;
    autoSpinCountdown = 0;
    quickBets = [];
    savedBalance = null;
    explodeSessions = [];

    constructor() {
        makeObservable(this, {
            userBalance: observable, spinAmount: observable, quickBets: observable, setUserBalance: action, setSpinAmount: action,
        });
    }

    getIsTurbo(){
        return this.isTurboMode && !getStores().freeSpinStore.freeSpin;
    }

    setExplodeSessions(explodeSessions){
        this.explodeSessions = explodeSessions;
    }

    setIsQuickFall(bool) {
        this.isQuickFall = bool;
    }

    setSavedBalance(balance) {
        this.savedBalance = balance;
    }

    updateBalanceFromSavedBalance() {
        if (this.savedBalance !== null) {
            this.setUserBalance(this.savedBalance);
            this.savedBalance = null;
        }
    }

    setQuickBets(quickBets) {
        this.quickBets = quickBets;
    }

    setBoardMatrix(matrix) {
        this.boardMatrix = matrix;
    }

    setWins(winsInfo) {
        this.wins = winsInfo;
        console.log(winsInfo.length);
    }

    setSpinAmount(amount) {
        this.spinAmount = amount;
    }

    setUserBalance(balance) {
        this.userBalance = balance;
    }

    setIsTurboMode(bool) {
        this.isTurboMode = bool;
    }

    setAutoSpinCountdown(number) {
        this.autoSpinCountdown = number;
        setAutoSpinBtnCountdownNumber(number);
    }

    setIsWonFreeSpin(bool) {
        this.isWonFreeSpin = bool;
    }

    setUserBalanceFromBackend() {
        getUserBalance(store.gameId).then((data) => {
            this.setUserBalance(data.data.realBalance);
        });
    }
}

export const spinStore = new SpinStore();

reaction(() => spinStore.userBalance, (newBalance) => {
    updateBalanceInfoText(newBalance);
    updateFreeBetBoard();
});


reaction(() => spinStore.spinAmount, (spinAmount) => {
    updateBetAmountInfoText(spinAmount);
    updateFreeBetBoard();
    updatePlusMinusButtonsOpacity(spinAmount);
    pixiComponents.questionModalBuyFreeSpins.questionText.updateFreeSpinPrice(spinAmount * 100);
});
